var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFhand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 90,
    viewBox: "0 0 77 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5446 78.3334C53.5446 78.3334 52.6171 69.754 52.6171 64.8847C52.6171 60.0153 52.6171 57.3487 50.994 52.9431C49.3709 48.5375 48.7912 42.8566 49.139 35.9004C49.4868 28.9441 49.9506 30.6832 49.7187 27.6688C49.4868 24.6544 48.8292 21.9879 49.0416 17.6982C49.255 13.4085 49.7187 10.742 51.9215 10.9739C54.1243 11.2057 52.6171 15.9592 52.6171 17.3504C52.6171 18.7416 52.965 22.1038 52.965 22.1038C52.965 22.1038 53.5446 27.7848 54.704 27.4369C55.8634 27.0891 56.4431 26.5094 56.3271 22.4516C56.2112 18.3938 56.9068 16.7707 57.1387 14.452C57.3706 12.1332 58.414 8.07542 58.7618 5.87261C59.1096 3.6698 60.4888 3.20606 61.3644 3.20606C62.2399 3.20606 63.0515 4.36543 62.5877 6.56824C62.124 8.77104 61.8921 11.4376 61.8921 11.4376C61.8921 11.4376 61.996 18.162 61.3644 21.0604C60.7328 23.9588 62.0461 26.2776 62.7222 23.4951C63.3993 20.7126 62.9356 17.4663 63.2834 14.2201C63.6312 10.9739 64.9065 7.61167 65.3702 5.75667C65.834 3.90168 65.6021 0.887311 68.2687 1.00325C70.9352 1.11919 69.7759 5.75667 69.428 7.3798C69.0802 9.00292 69.0802 10.9739 68.7324 13.7563C68.3846 16.5388 66.2977 27.0891 68.9643 25.1182",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9354 35.9003C70.9354 35.9003 68.6166 33.9293 68.7326 31.1469C68.8485 28.3644 69.0804 25.1181 70.9354 25.0022C72.7904 24.8862 72.9063 25.2341 73.486 29.1759C74.0657 33.1178 74.7613 30.3353 75.1091 34.9728C75.4569 39.6103 76.0366 41.2334 75.1091 43.2043C74.1816 45.1753 67.8051 51.5518 68.1529 56.4212C68.5007 61.2905 69.0804 63.2615 69.4282 68.5946C69.776 73.9277 71.8749 80.9999 71.8749 80.9999",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9789 25.4513C69.9789 25.4513 68.1526 25.5051 69.0801 22.7996C70.0076 20.0941 70.4565 19.5923 71.8747 19.5923C73.2928 19.5923 75.7627 19.9401 75.6097 22.7615C75.6097 22.7615 75.6885 24.5396 73.3698 25.2732L72.6065 25.4513",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2003 24.0083C75.2003 24.0083 75.1085 26.085 74.5677 27.747C74.027 29.4091 73.6542 30.3802 73.8406 30.8365",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4355 33.9778C69.4355 33.9778 69.1378 35.9246 69.4355 37.8714",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6914 65.3789H22.4414V77H16.582V48.5625H35.0977V53.3086H22.4414V60.6523H33.6914V65.3789Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 65.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFhand);
export default __webpack_public_path__ + "static/media/Fhand.deea63be921668a7a01e3632ff4833d7.svg";
export { ForwardRef as ReactComponent };